import { createContext, useEffect, useRef, useState } from 'react';

import { readDraft, writeDraft } from './draft';

export const AddOrderContext = createContext();

/**
 * @param {string} [props.draftKey] sessionStorage-ийн key. Дамжуулбал бөглөсөн
 * мэдээлэл refresh хийхэд сэргэнэ. Дамжуулаагүй бол хадгалахгүй.
 */
export const AddOrderProvider = ({ draftKey, children }) => {
  // Хуудас refresh хийхэд бөглөсөн мэдээлэл сэргэхийн тулд эхлэхдээ л уншина
  const draft = useRef(readDraft(draftKey)).current;

  const [products, setProducts] = useState(draft.products ?? []);
  const [finalProductList, setFinalProductList] = useState(draft.finalProductList ?? []);
  const [deliveryDateFinal, setDeliveryDateFinal] = useState(draft.deliveryDateFinal ?? '');
  const [deliveryTimeFinal, setDeliveryTimeFinal] = useState(draft.deliveryTimeFinal ?? '');
  const [description, setDescription] = useState(draft.description ?? '');
  const [totalWeight, setTotalWeight] = useState(draft.totalWeight);
  const [totalVolume, setTotalVolume] = useState(draft.totalVolume);
  const [carPrice, setCarPrice] = useState(draft.carPrice ?? 0);
  const [importantNotes, setImportantNotes] = useState(draft.importantNotes ?? []);
  const [branchCode, setBranchCode] = useState(draft.branchCode ?? '');
  const [typeMeat, setTypeMeat] = useState(draft.typeMeat ?? '');
  const [procurementType, setProcurementType] = useState(draft.procurementType ?? '');
  const [pricingCode, setPricingCode] = useState(draft.pricingCode ?? '');
  /**
   * Лавлах мэдээлэл (салбар, тарифын нэрс). 2-р алхам дээр татагддаг тул
   * 3-р алхам дээр refresh хийхэд нэрс нь "-" болохгүйн тулд хамт хадгална.
   */
  const [field, setField] = useState(draft.field ?? []);

  /** 1-р алхам дээр сонгосон, хараахан БАТЛААГҮЙ бараанууд */
  const [chosenProductList, setChosenProductList] = useState(draft.chosenProductList ?? []);

  const [formDataStep1, setFormDataStep1] = useState(draft.formDataStep1);
  const [formDataStep2, setFormDataStep2] = useState(draft.formDataStep2);

  /**
   * Алхам бүр дээр бөглөж байгаа (хараахан "Үргэлжлүүлээгүй") формын утгууд —
   * refresh хийхэд салбар, огноо, тэмдэглэл зэрэг нь сэргэнэ.
   */
  const [formValuesStep1, setFormValuesStep1] = useState(draft.formValuesStep1);
  const [formValuesStep2, setFormValuesStep2] = useState(draft.formValuesStep2);

  // Төлөв өөрчлөгдөх бүрд draft-ыг шинэчилнэ
  useEffect(() => {
    writeDraft(draftKey, {
      products,
      finalProductList,
      deliveryDateFinal,
      deliveryTimeFinal,
      description,
      totalWeight,
      totalVolume,
      carPrice,
      importantNotes,
      branchCode,
      typeMeat,
      procurementType,
      pricingCode,
      field,
      chosenProductList,
      formDataStep1,
      formDataStep2,
      formValuesStep1,
      formValuesStep2,
    });
  }, [
    draftKey,
    products,
    finalProductList,
    deliveryDateFinal,
    deliveryTimeFinal,
    description,
    totalWeight,
    totalVolume,
    carPrice,
    importantNotes,
    branchCode,
    typeMeat,
    procurementType,
    pricingCode,
    field,
    chosenProductList,
    formDataStep1,
    formDataStep2,
    formValuesStep1,
    formValuesStep2,
  ]);

  return (
    <AddOrderContext.Provider
      value={{
        draftKey,

        field,
        setField,

        chosenProductList,
        setChosenProductList,

        formDataStep1,
        setFormDataStep1,

        formDataStep2,
        setFormDataStep2,

        formValuesStep1,
        setFormValuesStep1,

        formValuesStep2,
        setFormValuesStep2,

        typeMeat,
        setTypeMeat,

        branchCode,
        setBranchCode,

        products,
        setProducts,

        finalProductList,
        setFinalProductList,

        deliveryDateFinal,
        setDeliveryDateFinal,

        deliveryTimeFinal,
        setDeliveryTimeFinal,

        description,
        setDescription,

        importantNotes,
        setImportantNotes,

        totalWeight,
        setTotalWeight,

        totalVolume,
        setTotalVolume,

        procurementType,
        setProcurementType,

        pricingCode,
        setPricingCode,

        carPrice,
        setCarPrice,
      }}
    >
      {children}
    </AddOrderContext.Provider>
  );
};
